import request from './common/request'
import qs from 'qs'

import { SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL } from './urls'

async function list (params) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${params.competitionId}/partner/${params.partnerId}/commissions`,
    method: 'GET'
  })
}

async function save (data) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.competitionId}/partner/${data.partnerId}/commissions`,
    method: 'POST',
    data: qs.stringify(data)
  })
}

export default {
  list,
  save
}



// WEBPACK FOOTER //
// ./src/api/merchant-simbart-activity-competition-partner-commission.js